import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import { color } from 'framer-motion';
import { CopyBlock, dracula } from "react-code-blocks";


const JavaScriptLesson63 = () => {
  const [language, changeLanguage] = useState("javascript");
  const [lineNumbers, toggleLineNumbers] = useState(false);
  const code1 = (
  'text',
  `
   function add(...elements){
     let sum = 0;
     for(let element of elements){
       sum+= element;
     }
     return sum;
   }
   console.log(add(2,4,6)); //12
  `
  );
  const code2 = (
  'text',
  `
   let snacks = ["meatpie", "sausage", "biscuit", "pizza"];
   let drinks = ["coke", "malt", "sprite", "fanta"]
   snacks.push(...drinks);
   console.log(snacks);
  `
  );
  const code3 = (
  'text',
  `
  let a, b, rest;
  [a, b] = [10, 20];
  console.log(a); //10
  console.log(b); //20
  [a,b, ...rest] = [10,20,30,40,50];
  console.log(rest) //Array[30,40,50]
  `
  );
  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">
    <h3><strong>Rest Parameter</strong></h3>
    <p>In JavaScript, the rest parameter syntax allows you to represent an indefinite number of arguments as an array within a function parameter. It provides a convenient way to work with functions that can accept a variable number of arguments. The rest parameter is indicated by three dots (...) followed by a parameter name.</p>
    <p>The <strong>rest parameter</strong> syntax allows a function to accept an indefinite number of arguments as an array.</p>
    <CopyBlock
    language={language}
    text={code1}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    <p className="mt-3">The rest parameter is also used to get the rest elements of an array</p>
    <CopyBlock
    language={language}
    text={code2}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />

    <div class="alert alert-secondary mt-3" role="alert">
    <h4><strong>De-structuring Assignment</strong></h4>
    <p><strong>Destructuring</strong> is the process of unpacking values from an array or properties from objects into distinct variables.</p>
    <CopyBlock
    language={language}
    text={code3}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    </div>

    </div>
    </div>
    </div>
    </HTMLCourseNavProvider>
  )
}

export default JavaScriptLesson63
